import { createSlice } from '@reduxjs/toolkit';
import { searchAdminContacts } from './thunks/searchAdminContacts.thunk';

export { searchAdminContacts };

// A plain array rather than an entity adapter: these are ephemeral search
// results, replaced wholesale, never addressed by id and never patched. The
// order is the server's, and normalizing it away would only have to be undone.
export const adminContactsSlice = createSlice({
  name: 'adminContacts',
  initialState: {
    results: [],
    loading: false,
    error: null,
    currentRequestId: null,
  },
  reducers: {
    clearAdminContacts(state) {
      state.results = [];
      state.loading = false;
      state.error = null;
      // Whatever is in flight is no longer wanted, so its response must not
      // repopulate a list the user has already dismissed.
      state.currentRequestId = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(searchAdminContacts.pending, (state, action) => {
        state.currentRequestId = action.meta.requestId;
        state.loading = true;
        state.error = null;
      })
      // axios 0.18 predates AbortController, so requests cannot be cancelled;
      // stale ones are dropped on arrival instead. Keyed on requestId, not on
      // the query, because the same text can legitimately be in flight twice.
      .addCase(searchAdminContacts.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.currentRequestId) return;
        state.results = action.payload ?? [];
        state.loading = false;
        state.currentRequestId = null;
      })
      .addCase(searchAdminContacts.rejected, (state, action) => {
        if (action.meta.requestId !== state.currentRequestId) return;
        state.loading = false;
        state.error = true;
        state.currentRequestId = null;
      });
  },
});

export const { clearAdminContacts } = adminContactsSlice.actions;

export default adminContactsSlice.reducer;
